import React, { useContext } from 'react';
import { Container, Layout, Row } from '../../components';
import styles from './styles.module.css';
import Detail from './Detail';
// import PaymentDetail from './PaymentDetails';
import Summary from './Summary';
import * as Icon from '../../components/Icons';
import { LanguageContext } from '../../context/Languages/LanguageProvider';

import cn from 'classnames';
import { Col } from 'react-flexbox-grid';

const Payment = () => {
  const { i18n } = useContext(LanguageContext);

  return (
    <Layout>
      <Container>
        <div className={styles.main}>
          <div className={styles.statusBar}>
            <ul>
              <li>
                <div className={cn([styles.icon, styles.bgActive])}>
                  <Icon.CheckIcon />
                </div>
                <div className={cn([styles.pageTitle, styles.deactive])}>{i18n.chooseYourRoom}</div>
                <div className={styles.seperator}></div>
              </li>
              <li>
                <div className={cn([styles.icon, styles.bgActive])}>
                  <Icon.CheckIcon />
                </div>
                <div className={cn([styles.pageTitle, styles.active])}>{i18n.enterYourDetail}</div>
                <div className={styles.seperator}></div>
              </li>
              <li>
                <div className={cn([styles.icon, styles.bgActive])}>3</div>
                <div className={cn([styles.pageTitle])}>{i18n.finalDetails}</div>
              </li>
            </ul>
          </div>
          <div className={styles.goBack}>
            <Icon.LeftArrow style={{ paddingTop: '5px' }} /> {i18n.backToRoomSelection}
          </div>
          <Row>
            <Col lg={3}>
              <div className={styles.right}>
                <Summary />
              </div>
            </Col>
            <Col lg={9}>
              <div className={styles.left}>
                {/* <PaymentDetail /> */}
                <Detail />
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </Layout>
  );
};

export default Payment;
